import { Component } from 'react';

import InfoBlock, { InfoBlockProps } from '../InfoBlock';

import WaveEventInfoWrapper from './Wrapper';

export interface WaveEventInfoProps {
  info: InfoBlockProps;
  className?: string;
}

class WaveEventInfo extends Component<WaveEventInfoProps> {
  render() {
    const { info, children, className } = this.props;

    return (
      <WaveEventInfoWrapper className={className}>
        <InfoBlock {...info} />
        {children}
      </WaveEventInfoWrapper>
    );
  }
}

export default WaveEventInfo;
